import { TTableStructureColors, TTableStructureFilter } from 'ui/EasTable/types';

export const EU_DDP_SLICE_NAME = '@@euDdp';

export enum EEuDdpOrderCustomsResult {
	CONTAINS_ERRORS = 'Contains errors',
	SUBMITTED = 'Submitted',
	ACCEPTED = 'Accepted',
	BEING_CHECKED = 'Being checked',
	GOODS_NOT_RELEASED = 'Goods not released',
	GOODS_RELEASED = 'Goods released',
	CHECKING = 'Checking',
	HOLD = 'Hold',
	VALIDATION_NOK = 'Validation NOK',
}

export enum EEuDdpOrderCustomsResultCode {
	CONTAINS_ERRORS = 'CONTAINS_ERRORS',
	SUBMITTED = 'SUBMITTED',
	ACCEPTED = 'ACCEPTED',
	BEING_CHECKED = 'BEING_CHECKED',
	GOODS_NOT_RELEASED = 'GOODS_NOT_RELEASED',
	GOODS_RELEASED = 'GOODS_RELEASED',
	CHECKING = 'CHECKING',
	HOLD = 'HOLD',
	VALIDATION_NOK = 'VALIDATION_NOK',
}

export const CUSTOMS_RESULT_FILTER: TTableStructureFilter = [
	[EEuDdpOrderCustomsResultCode.CONTAINS_ERRORS, EEuDdpOrderCustomsResult.CONTAINS_ERRORS],
	[EEuDdpOrderCustomsResultCode.SUBMITTED, EEuDdpOrderCustomsResult.SUBMITTED],
	[EEuDdpOrderCustomsResultCode.ACCEPTED, EEuDdpOrderCustomsResult.ACCEPTED],
	[EEuDdpOrderCustomsResultCode.BEING_CHECKED, EEuDdpOrderCustomsResult.BEING_CHECKED],
	[EEuDdpOrderCustomsResultCode.GOODS_NOT_RELEASED, EEuDdpOrderCustomsResult.GOODS_NOT_RELEASED],
	[EEuDdpOrderCustomsResultCode.GOODS_RELEASED, EEuDdpOrderCustomsResult.GOODS_RELEASED],
	[EEuDdpOrderCustomsResultCode.CHECKING, EEuDdpOrderCustomsResult.CHECKING],
	[EEuDdpOrderCustomsResultCode.HOLD, EEuDdpOrderCustomsResult.HOLD],
	[EEuDdpOrderCustomsResultCode.VALIDATION_NOK, EEuDdpOrderCustomsResult.VALIDATION_NOK],
];
export const CUSTOMS_RESULT_COLORS: TTableStructureColors = [
	[EEuDdpOrderCustomsResultCode.CONTAINS_ERRORS, 'error.light'],
	[EEuDdpOrderCustomsResultCode.SUBMITTED, 'warning.light'],
	[EEuDdpOrderCustomsResultCode.ACCEPTED, 'success.light'],
	[EEuDdpOrderCustomsResultCode.BEING_CHECKED, 'error.light'],
	[EEuDdpOrderCustomsResultCode.GOODS_NOT_RELEASED, 'error.light'],
	[EEuDdpOrderCustomsResultCode.GOODS_RELEASED, 'success.light'],
	[EEuDdpOrderCustomsResultCode.CHECKING, 'error.light'],
	[EEuDdpOrderCustomsResultCode.HOLD, 'error.light'],
	[EEuDdpOrderCustomsResultCode.VALIDATION_NOK, 'error.light'],
];
